var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-autocomplete',{staticClass:"mo-autocomplete",attrs:{"md-layout":"box","md-options":_vm.placesPredictions},on:{"md-changed":_vm.getPlacePredictions,"md-selected":_vm.selectPrediction},scopedSlots:_vm._u([{key:"md-autocomplete-item",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(item.description))]}}]),model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},[_c('label',[_vm._v(_vm._s(_vm.keywordPlaceholder))])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06fb4376","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/adrSearchBar.vue
// module id = null
// module chunks = 